var map = {
	"./Group 22302.png": 1316,
	"./avatar-christmas.webp": 1317,
	"./bottom-bg-christmas.webp": 1318,
	"./btn-active.png": 1319,
	"./content-deco-1.webp": 1320,
	"./content-deco-2.webp": 1321,
	"./content-deco-3.webp": 1322,
	"./content-deco-4.webp": 1323,
	"./deco-3.webp": 1324,
	"./deposit-icon.webp": 1325,
	"./home-icon-active.webp": 1326,
	"./home-icon.webp": 1327,
	"./live-icon-active.webp": 1328,
	"./live-icon.webp": 1329,
	"./master-bg.jpg": 1330,
	"./me-icon-active.webp": 1331,
	"./me-icon.webp": 1332,
	"./platform.png": 1333,
	"./platform.webp": 1334,
	"./promos-icon-active.webp": 1335,
	"./promos-icon.webp": 1336,
	"./promos.webp": 1337,
	"./service-christmas.webp": 1338,
	"./snowman.webp": 1339,
	"./sponsor-icon-active.webp": 1340,
	"./sponsor-icon.webp": 1341,
	"./title-deco-left.webp": 1342,
	"./title-deco-right.webp": 1343,
	"./tree.webp": 1344,
	"./vip-icon.webp": 1345,
	"./vip.webp": 1346,
	"./withdraw-icon.webp": 1347,
	"./wwr-img.webp": 1348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;